export default __webpack_public_path__ + "static/media/mobile_colony_status_en.80f100df.png";